var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.isLoading
        ? _c("div", { staticClass: "qualifier-tool-loading" })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 0
        ? _c("wqtstep1", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 1
        ? _c("wqtstep2a", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 2
        ? _c("wqtstep2b", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 3
        ? _c("wqtstep3a", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 4
        ? _c("wqtstep3b", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 5
        ? _c("wqtstep3c", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 6
        ? _c("wqtstep3d", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 7
        ? _c("wqtstep3e", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 14
        ? _c("wqtstep3f", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 8
        ? _c("wqtstep4a", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 9
        ? _c("wqtstep4b", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 10
        ? _c("wqtstep5a", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 11
        ? _c("wqtstep5b", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 12
        ? _c("wqtstep6a", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 13
        ? _c("wqtstep6b", { attrs: { model: _vm.model } })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 15
        ? _c("wqtstep6c", { attrs: { model: _vm.model } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }